/**
 * Handling collapse!
 *
 * @package backpress
 * @since 1.0.0
 * @author hype.media <web@hype-media.de>
 */

export function searchCollapse() {
    const searchBarCollapse = $('#search-bar');
    const searchBarAction = $('.search-action');

    searchBarAction.on('click', (e) => {
        e.preventDefault();
        searchBarAction.toggleClass('open');
        searchBarCollapse.collapse('toggle');
    });
}

export function wishlistCollapse() {
    const whishlistCollapse = $('#whishlist');
    const whishlistAction = $('.whishlist-action');

    whishlistAction.on('click', (e) => {
        e.preventDefault();
        whishlistAction.toggleClass('open');
        whishlistCollapse.collapse('toggle');
    });
}
